"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CarouselNavList;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/styles");
const NavListItem_1 = __importDefault(require("./NavListItem/NavListItem"));
const index_1 = require("../../index");
const useStyles = (0, styles_1.makeStyles)({
    listItem: { marginBottom: index_1.StyleVariables.spacing(2), left: 0 },
});
function CarouselNavList({ items, seletedIndex, onItemSelect, ...rest }) {
    const classes = useStyles();
    return (react_1.default.createElement("div", { ...rest }, items.map((item, index) => (react_1.default.createElement("div", { key: item },
        react_1.default.createElement(NavListItem_1.default, { label: item, isSelected: index === seletedIndex, className: classes.listItem, onClick: () => onItemSelect(index), "data-testid": item }))))));
}
